module.exports = __webpack_public_path__ + "img/address.9503365e.jpg";